import { gql } from '@apollo/client';
import { WorkflowExecutionThreadStatus } from 'src/interfaces/workflows.interface';

export const GET_CALLS_GROUPED_BY_STATUS = gql`
  query GetCallsGroupedByStatus(
    $startDate: DateTime!
    $endDate: DateTime!
    $agentId: String
    $minDurationSecs: Float
    $maxDurationSecs: Float
    $callDirection: String
  ) {
    getCallsGroupedByStatus(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      minDurationSecs: $minDurationSecs
      maxDurationSecs: $maxDurationSecs
      callDirection: $callDirection
    ) {
      executionDate
      status
      count
    }
  }
`;

export const GET_CALLS_GROUPED_BY_STAGE_OUTCOME = gql`
  query GetCallsGroupedByStageOutcome(
    $startDate: DateTime!
    $endDate: DateTime!
    $agentId: String
    $minDurationSecs: Float
    $maxDurationSecs: Float
    $callDirection: String
  ) {
    getCallsGroupedByStageOutcome(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      minDurationSecs: $minDurationSecs
      maxDurationSecs: $maxDurationSecs
      callDirection: $callDirection
    ) {
      executionDate
      stageOutcome
      count
    }
  }
`;

export const GET_CALLS_GROUPED_BY_STAGE = gql`
  query getCallsGroupedByStage(
    $startDate: DateTime!
    $endDate: DateTime!
    $agentId: String
    $minDurationSecs: Float
    $maxDurationSecs: Float
    $callDirection: String
  ) {
    getCallsGroupedByStage(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      minDurationSecs: $minDurationSecs
      maxDurationSecs: $maxDurationSecs
      callDirection: $callDirection
    ) {
      executionDate
      stage
      count
    }
  }
`;

export const GET_CALLS_BY_HOUR_PST = gql`
  query getCallsByHourPST(
    $startDate: DateTime!
    $endDate: DateTime!
    $agentId: String
    $minDurationSecs: Float
    $maxDurationSecs: Float
    $callDirection: String
  ) {
    getCallsByHourPST(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      minDurationSecs: $minDurationSecs
      maxDurationSecs: $maxDurationSecs
      callDirection: $callDirection
    ) {
      callHour
      callCount
    }
  }
`;

export const GET_CALL_ACTIONS = gql`
  query getCallActions(
    $startDate: DateTime!
    $endDate: DateTime!
    $agentId: String
    $minDurationSecs: Float
    $maxDurationSecs: Float
    $callDirection: String
  ) {
    getCallActions(
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
      minDurationSecs: $minDurationSecs
      maxDurationSecs: $maxDurationSecs
      callDirection: $callDirection
    ) {
      actionName
      actionType
      numCalls
      percentCalls
    }
  }
`;

export type WorkflowStatusDto = {
  __typename?: 'WorkflowStatusesDto';
  workflowReferenceId: string;
  count: number;
  status: WorkflowExecutionThreadStatus;
};

export type GetWorkflowStatsQueryData = {
  getWorkflowStats: WorkflowStatusDto[];
};

export type GetWorkflowStatsQueryVariables = {
  environmentId: string;
  workflowReferenceIds: string[];
};

export const GET_WORKFLOW_STATS = gql`
  query getWorkflowStats(
    $environmentId: String!
    $workflowReferenceIds: [String!]!
  ) {
    getWorkflowStats(
      environmentId: $environmentId
      workflowReferenceIds: $workflowReferenceIds
    ) {
      workflowReferenceId
      count
      status
    }
  }
`;
